import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  getDetailKickPointRedemption,
  saveKickPointRedemption,
  newKickPointRedemption,
} from '../../actions/kickPointRedemptionAction';
import KickPointRedemption from './KickPointRedemption';

/**
 * Connected wrapper for Kick Point Redemption create/detail — mirrors
 * ProductVariantForm.js but trimmed to the redemption entity (no images,
 * sizes, vouchers, etc.).
 */
class KickPointRedemptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _hasId: props.match.params.id ? true : false,
      _id: props.match.params.id,
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (this.state._hasId) this.props.find(this.state._id);
    else this.props.new();
  }

  onSubmit(payload) {
    this.props.save(payload, this.state._id);
  }

  renderInfo() {
    const { isSubmit, success, error, isFetch } = this.props.kickPointRedemption;
    let messages = [];
    if (isSubmit)
      messages.push(<Alert color="info" key="info"><strong>Heads up!</strong> Submitting...</Alert>);
    if (success)
      messages.push(<Alert color="success" key="success"><strong>Well done!</strong> {success}</Alert>);
    if (error !== null && !isFetch) {
      const { status_code } = error;
      switch (status_code) {
        case 422:
          messages.push(<Alert color="danger" key="error"><strong>Oh Snap!</strong> Please fulfill your form.</Alert>);
          break;
        case 404:
          messages.push(<Alert color="danger" key="error"><strong>Oh Snap!</strong> Resource not found.</Alert>);
          break;
        default:
          messages.push(<Alert color="danger" key="error"><strong>Oh Snap!</strong> We've got something errors.</Alert>);
          break;
      }
    }
    return (
      <div className="row">
        <div className="col-sm-12">{messages}</div>
      </div>
    );
  }

  render() {
    const { kickPointRedemption } = this.props;
    return (
      <Row>
        <Col xs={12} md={{ size: 8, offset: 2 }}>
          <Card>
            <CardHeader>
              <i className="fa fa-align-justify"></i> {this.props.title}{' '}
              {this.props.edit ? (
                <Link
                  to="/kick_point_redemptions/create"
                  title="Create New Kick Point Redemption"
                  className="text-right"
                >
                  Create New
                </Link>
              ) : null}
            </CardHeader>
            <CardBody>
              {this.renderInfo()}
              <KickPointRedemption
                edit={this.props.edit}
                isLoading={kickPointRedemption.isFetch}
                isSubmitProgress={kickPointRedemption.isSubmit}
                data={kickPointRedemption.detail}
                error={kickPointRedemption.error}
                onSubmit={this.onSubmit}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  kickPointRedemption: state.kickPointRedemption,
});

const mapDispatchToProps = (dispatch) => ({
  find: id => dispatch(getDetailKickPointRedemption(id)),
  save: (payload, id) => dispatch(saveKickPointRedemption(payload, id)),
  new: () => dispatch(newKickPointRedemption()),
});

export default connect(mapStateToProps, mapDispatchToProps)(KickPointRedemptionForm);

KickPointRedemptionForm.propTypes = {
  edit: PropTypes.bool,
  title: PropTypes.string,
};

KickPointRedemptionForm.defaultProps = {
  edit: false,
  title: 'Kick Point Redemption',
};
